// One update: separate setFieldValue calls race and leave Continuer
// disabled after this optional consent is unchecked.
export const withPhoneCanvassingChange = (fields = {}, checked) => ({
  ...fields,
  phoneCanvassing: checked,
  ...(checked ? {} : { phoneCanvassingConsent: false }),
});

export const applyPhoneCanvassingChange = (setValues, values, checked) => {
  setValues(
    {
      ...values,
      fields: withPhoneCanvassingChange(values && values.fields, checked),
    },
    true,
  );
};
